import { FormValidations } from "features/shared/forms/hooks/useForm";

export const contractingPrepareFormValidations = (): FormValidations  => {
  return {
    authorizedPersonId: {
      required: true,
      type: "OnlyRequired",
      requiredMessage: "contractingPrepareFormValidation.authorizedPersonId"
    }
  };
}